import api from '@/services/api/config';

const path = 'v2/infra/artikel';

export default {
  search: (page, size, sort = null, desc = false, suche = null, einkaufsteil = null, verkaufsteil = null, status = null, hasWep = null) => api.get(path, {
    params: {
      page, size, sort, desc, suche, einkaufsteil, verkaufsteil, status, 'has-wep': hasWep,
    },
  }),
  getByArtikelnummer(artikelnummer) {
    return api.get(`${path}/${artikelnummer}`);
  },
};
